(() => {
  const overlay = document.querySelector('[data-gallery-overlay]');
  const openBtn = document.querySelector('[data-gallery-open]');
  const closeBtn = document.querySelector('[data-gallery-close]');
  if (!overlay || !openBtn || !closeBtn) return;

  const bg = overlay.querySelector('.lp-hitotsu-gallery__overlay-bg');

  const open = () => {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('is-modal-open');
  };

  const close = () => {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('is-modal-open');
  };

  openBtn.addEventListener('click', open);
  closeBtn.addEventListener('click', close);
  bg && bg.addEventListener('click', close);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
      close();
    }
  });
})();

// ======== フェードアップ ==========================
document.addEventListener('DOMContentLoaded', () => {
  const targets = document.querySelectorAll('.fadeUp-on-scroll, .fadeUp-on-scroll--slow');
  if (!targets.length) return;

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { root: null, rootMargin: '0px 0px -10% 0px', threshold: 0 });

  targets.forEach(t => observer.observe(t));
});
